
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Innovacrystaonrentinpune() {



    const cardData =
    {
        keyword: 'Innova Crysta on Rent in Pune',
        heading: 'Morya Cabs: Innova Crysta on Rent in Pune',
        headingDescription: 'Morya Cabs offers Innova Crysta on rent in Pune, ensuring a premium and comfortable travel experience. Whether you are traveling for an outstation trip, corporate event, family vacation, or airport transfer, our well-maintained Innova Crysta fleet provides a smooth and hassle-free journey. With luxurious interiors, ample space, and professional drivers, Morya Cabs guarantees a safe and enjoyable ride at affordable rates.',

        top: 'Best Uses for Innova Crysta Rental with Morya Cabs',

        "topPlaces": [
            {
              "title": "Corporate Travel",
              "description": "For business professionals, comfort and punctuality are key. Morya Cabs offers Innova Crysta rental for corporate meetings, conferences, and office commutes, ensuring a smooth ride. With luxurious seating, WiFi (on request), and a quiet cabin, you can prepare for meetings or relax on the go."
            },
            {
              "title": "Airport Transfers",
              "description": "Our airport taxi services provide timely pickup and drop services to Pune Airport and Mumbai International Airport. No last-minute rush—just a reliable ride with ample luggage space, comfortable seating, and professional drivers to ensure stress-free airport transfers."
            },
            {
              "title": "Wedding & Family Events",
              "description": "Make your wedding or family gatherings more special with our Innova Crysta rental in Pune. Ideal for guests, brides, or grooms, our spacious vehicle ensures a grand and comfortable arrival. Whether it’s a wedding, anniversary, or family function, travel in luxury and convenience."
            },
            {
              "title": "City Travel",
              "description": "Exploring Pune or need a vehicle for daily travel? Our Innova Crysta rental offers a smooth ride for local sightseeing, shopping, or business errands. Whether you need a vehicle for a day tour, personal engagements, or simply a comfortable city commute, Morya Cabs ensures a premium travel experience."
            }
          ],


"services": [
    {
      "name": "Innova on Rent Pune",
      "description": "Morya Cab offers the Innova for rent in Pune, providing a comfortable and reliable vehicle for your local and outstation trips. Book your Innova today for a smooth and enjoyable journey."
    },
    {
      "name": "Innova Crysta Rental Pune",
      "description": "Morya Cab offers Innova Crysta rental services in Pune. Travel in style and comfort with this premium vehicle, perfect for long trips and corporate travel."
    },
    {
      "name": "Innova Car Hire in Pune",
      "description": "Need an Innova for your trip? Morya Cab provides Innova car hire services in Pune, ensuring you get the perfect vehicle for your journey. Choose from a range of well-maintained vehicles."
    },
    {
      "name": "Innova Car Rental in Pune",
      "description": "Morya Cab offers affordable and reliable Innova car rentals in Pune. Whether you're traveling for business or leisure, our vehicles provide ample space and comfort."
    },
    {
      "name": "Innova Crysta on Rent Pune",
      "description": "Rent an Innova Crysta in Pune from Morya Cab for a luxurious ride. With spacious interiors and top-notch features, the Innova Crysta ensures an exceptional travel experience."
    },
    {
      "name": "Innova Crysta Rent in Pune",
      "description": "For a premium experience, Morya Cab offers Innova Crysta on rent in Pune. This vehicle is ideal for both long-distance and local travel, providing maximum comfort and style."
    },
    {
      "name": "Pune Innova Rental",
      "description": "Morya Cab offers affordable and reliable Innova rentals in Pune. Whether you need a car for a day trip or a week-long journey, we have flexible rental options to suit your needs."
    },
    {
      "name": "Pune Mumbai Innova Rental",
      "description": "Morya Cab offers Innova rental services for your Pune to Mumbai journey. Enjoy a smooth ride with a professional driver, perfect for business or leisure trips between the cities."
    },
    {
      "name": "Pune to Bhimashankar Innova Crysta",
      "description": "Book an Innova Crysta for your Pune to Bhimashankar journey with Morya Cab. Our comfortable and spacious vehicles make your pilgrimage trip or leisure visit enjoyable."
    },
    {
      "name": "Pune to Shirdi Innova Crysta on Rent",
      "description": "Morya Cab provides Innova Crysta on rent for your trip from Pune to Shirdi. Travel in comfort and style while visiting the holy city."
    },
    {
      "name": "Pune to Mahabaleshwar Innova Cab",
      "description": "For a smooth and relaxing ride from Pune to Mahabaleshwar, book an Innova cab with Morya Cab. Enjoy scenic views and a comfortable journey in a spacious vehicle."
    },
    {
      "name": "Pune to Mumbai International Airport Innova Crysta on Rent",
      "description": "Morya Cab offers Innova Crysta rentals for airport transfers from Pune to Mumbai International Airport. Enjoy a comfortable ride with a professional driver for a stress-free travel experience."
    },
    {
      "name": "Pune to Nashik Innova Crysta on Rent",
      "description": "Book an Innova Crysta for your journey from Pune to Nashik with Morya Cab. Our vehicles are ideal for both short and long-distance trips, providing a comfortable and relaxing experience."
    },
    {
      "name": "Pune Airport Innova Crysta on Rent",
      "description": "Morya Cab offers Innova Crysta rentals for airport pick-ups and drop-offs at Pune Airport. Our drivers ensure timely and safe transport to and from the airport."
    },
    {
      "name": "Pune to Shirdi and Shani Shingnapur Innova Cab",
      "description": "Morya Cab offers a customized Innova cab service for your Pune to Shirdi and Shani Shingnapur trip. Enjoy a convenient and comfortable journey to these religious sites."
    },
    {
      "name": "Pune to Goa Innova Cab on Rent",
      "description": "Travel from Pune to Goa in comfort with Morya Cab’s Innova cab on rent. We offer a smooth and enjoyable long-distance ride, perfect for your vacation."
    },
    {
      "name": "Pune to Panchgani Innova Crysta on Rent",
      "description": "Book an Innova Crysta on rent for your Pune to Panchgani trip with Morya Cab. Travel in comfort and style with our well-maintained vehicles."
    },
    {
      "name": "Corporate Innova Crysta on Rent",
      "description": "Morya Cab offers corporate Innova Crysta rentals for business trips in Pune. Ensure a professional and comfortable travel experience for you and your team."
    },
    {
      "name": "7 Seater Innova on Rent in Pune",
      "description": "For group travel, Morya Cab offers a 7-seater Innova on rent in Pune. Whether it's a family outing or a corporate event, our vehicles provide plenty of space and comfort."
    },
    {
      "name": "Innova Crysta on Rent for Outstation",
      "description": "Morya Cab offers Innova Crysta on rent for your outstation trips. Book a vehicle for a comfortable, luxurious, and stress-free journey."
    },
    {
      "name": "Innova Per Km Rate for Outstation",
      "description": "Morya Cab offers competitive Innova per km rates for outstation journeys. Get in touch for detailed pricing and book your ride for a hassle-free trip."
    },
    {
      "name": "Innova Per Km Rate for Outstation Near Me",
      "description": "Find the best per km rates for an outstation Innova rental near you with Morya Cab. We provide affordable and transparent pricing for all your travel needs."
    },
    {
      "name": "Innova Crysta Monthly Rental in Pune",
      "description": "Morya Cab offers Innova Crysta for monthly rental in Pune, perfect for business or extended travel. Enjoy the convenience of a long-term vehicle rental with flexible options."
    },
    {
      "name": "Innova Crysta on Rent for Local Trip in Pune",
      "description": "Morya Cab offers Innova Crysta on rent for local trips within Pune. Experience the comfort and luxury of a premium vehicle for your short trips in the city."
    }
  ],


  tableData: [
    ["Innova On Rent Pune", "-Innova Crysta Rental Pune"],
    ["Innova Car Hire in Pune", "-Innova car rental in Pune"],
    ["Innova Crysta On Rent Pune", "Innova Crysta rent in Pune"],
    ["Pune Innova Rental", "-Pune Mumbai Innova Rental"],
    ["Pune to Bhimashankar Innova Crysta", "-Pune to Shirdi Innova Crysta on Rent"],
    ["Pune to Mahabaleshwar Innova Cab", "-Pune to Mumbai International Airport Innova Crysta on Rent"],
    ["Pune to Nashik Innova Crysta on Rent", "-Pune Airport Innova Crysta on Rent"],
    ["Pune to Shirdi and Shani Shingnapur Innova Cab", "-Pune to Goa Innova Cab on Rent"]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "At Morya Cab, we understand the value of your time. Whether it’s a business trip, family outing, or leisure travel, our Innova Crysta rentals ensure punctual pickups and timely drop-offs, so your trip is always hassle-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "The Toyota Innova Crysta is known for its spacious and luxurious interiors. With ample legroom, air conditioning, and comfortable seating, the Innova Crysta is designed to provide you and your passengers with a smooth and relaxing ride throughout your journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are highly trained and experienced in handling long-distance and city travel, ensuring a safe and smooth journey. They are knowledgeable about the best routes in Pune, ensuring efficiency and comfort."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Morya Cab offers competitive pricing for Innova Crysta rentals in Pune. We believe in complete transparency, with no hidden charges, and we provide you with a clear breakdown of the costs upfront."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. The Innova Crysta comes equipped with modern safety features like airbags, seat belts, and GPS tracking to ensure a secure and comfortable ride for you and your loved ones."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Morya Cab operates around the clock. Whether you need an early morning ride or a late-night return, we are always available to meet your travel needs. Our customer service team is ready to assist you at any time."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking an Innova Crysta is simple and convenient. You can easily make a reservation via our website or app, or reach out to our customer service team for personalized assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you’re planning a family trip, a corporate outing, or a sightseeing tour, we offer customized travel packages with the Innova Crysta to cater to your specific needs. Let us know your requirements, and we’ll make sure your trip is special."
    }
]

















    }

    const faqData = [
        {
          question: "How can I book an Innova Crysta on rent with Morya Cab?",
          answer: "Booking an Innova Crysta is simple! You can book online through our website or app, or you can contact our customer service team for assistance with your booking."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, all our drivers are experienced and well-versed in handling long-distance travel, ensuring a smooth, safe, and comfortable journey."
        },
        {
          question: "What types of vehicles are available for rent besides Innova Crysta?",
          answer: "We offer a wide range of vehicles including sedans, SUVs, Tempo Travellers, and premium cars. If you prefer a different vehicle, let us know, and we’ll be happy to accommodate your preferences."
        },
        {
          question: "How do I pay for my Innova Crysta rental?",
          answer: "We offer several flexible payment options, including cash, credit/debit cards, and online payments via our app, making the process simple and secure."
        },
        {
          question: "Can I book a round trip with an Innova Crysta?",
          answer: "Yes, we offer round-trip bookings. Just let us know your return details, and we’ll take care of the rest."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "Any additional charges, such as for waiting time or detours, will be clearly communicated to you upfront, ensuring transparency."
        },
        {
          question: "Can I hire an Innova Crysta for sightseeing in Pune?",
          answer: "Yes, we offer sightseeing tours around Pune with the Innova Crysta. Explore the city’s major attractions in comfort with our professional drivers."
        },
        {
          question: "What is the luggage allowance for an Innova Crysta?",
          answer: "The Innova Crysta can comfortably accommodate standard luggage. If you have more luggage or special requirements, please let us know during booking, and we’ll make the necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel with an Innova Crysta?",
          answer: "Yes, we offer corporate travel services for business trips, meetings, and events, ensuring a comfortable and professional travel experience."
        },
        {
          question: "Why should I choose Morya Cab for Innova Crysta rentals in Pune?",
          answer: "Morya Cab ensures a reliable, comfortable, and safe journey with well-maintained vehicles, professional drivers, and transparent pricing. Whether it’s for business or leisure, we guarantee a pleasant travel experience every time."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Sanjay Patil',
          role: 'Family Traveler',
          review: "I rented an Innova Crysta for a family trip to Mahabaleshwar. The vehicle was luxurious, comfortable, and clean, and the driver was friendly and professional. We had a wonderful trip, and I would highly recommend Morya Cab!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Ms. Rina Sharma',
          role: 'Corporate Executive',
          review: "We used Morya Cab’s Innova Crysta for a corporate outing in Pune. The vehicle was spacious and perfect for our team, and the service was excellent. The driver was prompt and ensured we had a smooth journey. Highly recommended!",
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      
      







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];





    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta On Rent in Pune",
  "image": "https://moryacab.com/assets/images/innova-crysta-on-rent-in-pune.jpg",
  "description": "Book Innova Crysta on rent in Pune with Morya Cab. Spacious and comfortable AC Innova Crysta available with professional drivers for family trips, corporate travel, weddings, and outstation journeys. Affordable fares, clean vehicles, and reliable service for a premium travel experience.",
  "brand": {
    "@type": "Brand",
    "name": "Morya Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8675"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://moryacab.com/innova-crysta-on-rent-in-pune"
  }
};








    return (
        <div>
            <UsePageTracking/>


<Helmet>
  <title>Innova Crysta On Rent in Pune | Luxury Car Hire – Morya Cab</title>
  <meta
    name="description"
    content="Hire Innova Crysta on rent in Pune with Morya Cab. Spacious AC vehicle with verified drivers for family trips, corporate travel, weddings & outstation cab bookings. Affordable fares & premium comfort."
  />
  <meta
    name="keywords"
    content="Innova Crysta on rent in Pune, Innova Crysta taxi Pune, Innova Crysta car rental Pune, Hire Innova Crysta Pune, Innova Crysta outstation cab Pune, Pune to Mumbai Innova Crysta, Innova Crysta for wedding Pune, Luxury Innova Crysta cab Pune, Innova Crysta booking Pune, Morya Cab Innova Crysta Pune"
  />
  <link rel="canonical" href="https://moryacab.com/innova-crysta-on-rent-in-pune" />
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Innova Crysta On Rent in Pune | Luxury Car Hire – Morya Cab" />
  <meta property="og:description" content="Book Innova Crysta rental in Pune with Morya Cab. Clean AC cars, verified drivers & affordable pricing for family, corporate & outstation travel." />
  <meta property="og:url" content="https://moryacab.com/innova-crysta-on-rent-in-pune" />
  <meta property="og:image" content="https://moryacab.com/assets/images/innova-crysta-on-rent-in-pune.jpg" />
  <meta name="twitter:card" content="summary_large_image" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #0AB4A9',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Innovacrystaonrentinpune;